import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "head flex-left" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "sym" }
const _hoisted_4 = {
  key: 0,
  class: "nick"
}
const _hoisted_5 = { class: "infos table-shadow" }
const _hoisted_6 = { class: "detail flex-left" }
const _hoisted_7 = { class: "item" }
const _hoisted_8 = { class: "item-text flex-left" }
const _hoisted_9 = { class: "item-text flex-left" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "item" }
const _hoisted_12 = { class: "item-text flex-left" }
const _hoisted_13 = { class: "item-text flex-left" }

import { computed } from "vue";
import { formatTime } from "@/utils/filters";
import type { TokenDetailDisplay } from "@/mixins/useTokenDetail";


export default /*@__PURE__*/_defineComponent({
  __name: 'TokenInfos',
  props: {
    infos: {},
    loading: { type: Boolean },
    variant: { default: "default" }
  },
  setup(__props: any) {

const props = __props;

function formatTotalSupply(infos: TokenDetailDisplay): string {
  if (infos.total_formatted != null && infos.total_formatted !== "") {
    const n = Number(infos.total_formatted);
    if (!Number.isNaN(n)) return n.toLocaleString();
    return String(infos.total_formatted);
  }
  if (infos.total != null && infos.decimals != null) {
    const decimals = infos.decimals || 18;
    const total = Number(infos.total) / Math.pow(10, decimals);
    if (!Number.isNaN(total)) return total.toLocaleString();
  }
  return "-";
}

const deployLabel = computed(() => {
  const raw = props.infos.deploy_time;
  if (raw == null || raw === "") return "-";
  const t =
    typeof raw === "number"
      ? raw
      : /^\d+$/.test(String(raw))
      ? Number(raw)
      : new Date(String(raw)).getTime();
  if (Number.isNaN(t)) return "-";
  return String(formatTime(t));
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["token-infos", { 'token-infos--pc': _ctx.variant === 'pc' }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _ctx.infos.icon,
        alt: "",
        class: "head-icon"
      }, null, 8, _hoisted_2),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.infos.symbol), 1),
      (_ctx.infos.nickname)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, " (" + _toDisplayString(_ctx.infos.nickname) + ")", 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "title" }, "概况", -1)),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", _hoisted_8, [
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "dot dot-red" }, null, -1)),
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "item-title" }, "发行总量", -1)),
            _createElementVNode("span", null, _toDisplayString(formatTotalSupply(_ctx.infos)), 1)
          ]),
          _createElementVNode("p", _hoisted_9, [
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "dot dot-blue" }, null, -1)),
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "item-title" }, "合约地址", -1)),
            (_ctx.infos.address)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: `/address?address=${_ctx.infos.address}`,
                  class: "light adr-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.infos.address), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_10, "-"))
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("p", _hoisted_12, [
            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "dot dot-red" }, null, -1)),
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "item-title" }, "精度", -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.infos.decimals != null ? _ctx.infos.decimals : "-"), 1)
          ]),
          _createElementVNode("p", _hoisted_13, [
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "dot dot-blue" }, null, -1)),
            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "item-title" }, "发行时间", -1)),
            _createElementVNode("span", null, _toDisplayString(deployLabel.value), 1)
          ])
        ])
      ])
    ])
  ], 2)), [
    [_directive_loading, _ctx.loading]
  ])
}
}

})